import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const Settings = ({ token }) => {
  const [namaSekolah, setNamaSekolah] = useState('');
  const [alamatSekolah, setAlamatSekolah] = useState('');
  const [logo, setLogo] = useState(null);
  const [preview, setPreview] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get('https://sijapan.sman10fajarharapan.sch.id/api/settings', {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data) {
        setNamaSekolah(res.data.nama_sekolah || '');
        setAlamatSekolah(res.data.alamat_sekolah || '');
        if (res.data.logo_path) {
            setPreview(`https://sijapan.sman10fajarharapan.sch.id/uploads/${res.data.logo_path}`);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('nama_sekolah', namaSekolah);
    formData.append('alamat_sekolah', alamatSekolah);
    if (logo) {
      formData.append('logo', logo);
    }

    try {
      const res = await axios.put('https://sijapan.sman10fajarharapan.sch.id/api/settings', formData, {
        headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
      });
      Swal.fire('Sukses', 'Pengaturan sekolah berhasil disimpan!', 'success');
      if(res.data.logo) setPreview(`https://sijapan.sman10fajarharapan.sch.id/uploads/${res.data.logo}`);
    } catch (err) {
      Swal.fire('Gagal', 'Terjadi kesalahan saat menyimpan.', 'error');
    }
    setLoading(false);
  };

  const handleEmergencyReset = async () => {
      const result = await Swal.fire({
          title: 'Reset Password Admin?',
          text: "Password user 'admin' akan direset menjadi 'admin123'. Gunakan hanya jika darurat!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Ya, Reset!'
      });

      if (result.isConfirmed) {
          try {
              await axios.get('https://sijapan.sman10fajarharapan.sch.id/api/emergency-reset');
              Swal.fire('Selesai', 'Password admin kembali ke: admin123', 'success');
          } catch (err) {
              Swal.fire('Gagal', 'Error server.', 'error');
          }
      }
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      <h2 style={{ color: '#1e293b', marginBottom: '20px' }}>⚙️ Pengaturan Sekolah</h2>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '30px' }}>
          
          {/* FORM IDENTITAS SEKOLAH */}
          <div style={{ background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0' }}>
              <form onSubmit={handleSave}>
                  <div style={{ marginBottom: '20px' }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#64748b' }}>Nama Sekolah</label>
                      <input 
                        type="text" 
                        value={namaSekolah} 
                        onChange={e => setNamaSekolah(e.target.value)} 
                        style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
                        placeholder="Contoh: SMAN 10 Fajar Harapan"
                      />
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#64748b' }}>Alamat Lengkap</label>
                      <textarea 
                        rows="3"
                        value={alamatSekolah} 
                        onChange={e => setAlamatSekolah(e.target.value)} 
                        style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontFamily: 'sans-serif' }}
                        placeholder="Alamat sekolah..."
                      ></textarea>
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#64748b' }}>Upload Logo Sekolah</label>
                      <input 
                        type="file" 
                        accept="image/*"
                        onChange={handleFileChange}
                        style={{ width: '100%', padding: '10px', background: '#f8fafc', borderRadius: '8px', border: '1px dashed #cbd5e1' }}
                      />
                      <small style={{ color: '#94a3b8' }}>*Format: JPG/PNG. Maksimal 2MB.</small>
                  </div>

                  <button 
                    type="submit" 
                    disabled={loading}
                    style={{ background: '#4361ee', color: 'white', padding: '12px 25px', borderRadius: '8px', border: 'none', fontWeight: 'bold', fontSize: '15px', cursor: 'pointer', marginTop: '10px' }}
                  >
                      {loading ? 'Menyimpan...' : '💾 Simpan Perubahan'}
                  </button>
              </form>
          </div>

          {/* PREVIEW & TOOLS */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              
              {/* KARTU PREVIEW */}
              <div style={{ background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0', textAlign: 'center' }}>
                  <h4 style={{ margin: '0 0 20px', color: '#64748b' }}>Preview Logo</h4>
                  <div style={{ width: '120px', height: '120px', margin: '0 auto 15px', borderRadius: '50%', border: '3px solid #e2e8f0', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f1f5f9' }}>
                      {preview ? (
                          <img src={preview} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                          <span style={{ fontSize: '40px', color: '#cbd5e1' }}>🏫</span>
                      )}
                  </div>
                  <p style={{ fontWeight: 'bold', color: '#334155', margin: 0 }}>{namaSekolah || 'Nama Sekolah'}</p>
                  <p style={{ fontSize: '13px', color: '#64748b', margin: '5px 0 0' }}>{alamatSekolah || 'Alamat Sekolah'}</p>
              </div>

              {/* KARTU DARURAT */}
              <div style={{ background: '#fee2e2', padding: '20px', borderRadius: '12px', border: '1px solid #fca5a5' }}>
                  <h4 style={{ margin: '0 0 10px', color: '#991b1b' }}>🚨 Area Berbahaya</h4>
                  <p style={{ fontSize: '13px', color: '#b91c1c', marginBottom: '15px' }}>
                      Gunakan tombol ini jika Admin lupa password. Password akan direset ke default.
                  </p>
                  <button 
                    onClick={handleEmergencyReset}
                    style={{ width: '100%', background: '#ef4444', color: 'white', padding: '10px', borderRadius: '6px', border: 'none', fontWeight: 'bold', cursor: 'pointer' }}
                  >
                      ⚠️ Reset Password Admin
                  </button>
              </div>

          </div>
      </div>
    </div>
  );
};

export default Settings;